// src/store/Slices/marketSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import BASE_URL from '../../API/config';

// Async thunk to fetch market data
export const fetchMarketData = createAsyncThunk('market/fetchMarketData', async () => {
  // ملاحظة: تأكد أن BASE_URL يشمل البروتوكول (http/https)
  const { data } = await axios.get(`${BASE_URL}/coins/market`);

  // API يُرجع topGainers و topLosers، فنحوّلها هنا لتتوافق مع حالة الفرونت
  // (allHotCoins قادمة كما هي)
  return {
    allHotCoins: data.allHotCoins || [],
    gainers: data.topGainers || [],
    losers: data.topLosers || [],
    // إن احتجت مستقبلاً:
    // topVolume: data.topVolume || [],
  };
});

const marketSlice = createSlice({
  name: 'market',
  initialState: {
    allHotCoins: [],
    gainers: [],
    losers: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMarketData.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchMarketData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.allHotCoins = action.payload.allHotCoins;
        state.gainers = action.payload.gainers;
        state.losers = action.payload.losers;
      })
      .addCase(fetchMarketData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error?.message || 'Failed to fetch market data';
      });
  },
});

export default marketSlice.reducer;
